export function DealershipAdvertisingSettingsCtrl (
  $q, 
  $scope, 
  $state, 
  $stateParams, 
  $translate, 
  $window, 
  confirm, 
  Dealership, 
  messages, 
  sessionObjAPI, 
  streamSearch, 
  workshopAPI, 
  company, 
  advertising
) {

  $scope.company    = company;
  $scope.Dealership = new Dealership(advertising);

  $scope.save = function () {
    $scope.Dealership.saveAdvertisingSettings().then(function () {
      messages.show($translate.instant('JS_SPACE.MESSAGES.SAVED.DEALERSHIP_ADVERTISING_SETTINGS'), 'success');
    }, function (error) {
      messages.error(error);
    });
  };

  $scope.save_form = function (form) {
    $scope.Dealership.saveAdvertisingSettings().then(function () {
      messages.show($translate.instant('JS_SPACE.MESSAGES.SAVED.DEALERSHIP_ADVERTISING_SETTINGS'), 'success');
      $state.reload();
    }, function (error) {
      messages.error(error);
    });
  };

  $scope.clearPasswords = function(sale_type, field) {
    if (field) {
      $scope.Dealership.advertising_settings[field] = '';
    }
    else {
      if (sale_type == 'carsales') {
        $scope.Dealership.advertising_settings.carsales_password = '';
        $scope.Dealership.advertising_settings.carsales_confirm_password = '';
      }
      else if (sale_type == 'bikesales') {
        $scope.Dealership.advertising_settings.bikesales_password = '';
        $scope.Dealership.advertising_settings.bikesales_confirm_password = '';
      }
      else if (sale_type == 'boatsales') {
        $scope.Dealership.advertising_settings.boatsales_password = '';
        $scope.Dealership.advertising_settings.boatsales_confirm_password = '';
      }
      else if (sale_type == 'trucksales') {
        $scope.Dealership.advertising_settings.trucksales_password = '';
        $scope.Dealership.advertising_settings.trucksales_confirm_password = '';
      }
      else if (sale_type == 'constructionsales') {
        $scope.Dealership.advertising_settings.constructionsales_password = '';
        $scope.Dealership.advertising_settings.constructionsales_confirm_password = '';
      }
      else if (sale_type == 'farmmachinerysales') {
        $scope.Dealership.advertising_settings.farmmachinerysales_password = '';
        $scope.Dealership.advertising_settings.farmmachinerysales_confirm_password = '';
      }
      else if (sale_type == 'caravancampingsales') {
        $scope.Dealership.advertising_settings.caravancamping_password = '';
        $scope.Dealership.advertising_settings.caravancamping_confirm_password = '';
      }
    }
  };

};